import * as type from "../../types/API/bomFinishedGoods";
import { IAction } from "../userMetadataReducer";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const getBOMFinishedGoodsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.GET_BOM_FINISHED_GOODS:
      return {
        ...state,
        loading: true,
      };
    case type.GET_BOM_FINISHED_GOODS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData,
      };
    case type.GET_BOM_FINISHED_GOODS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const addBOMFinishedGoodsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.ADD_BOM_FINISHED_GOODS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.ADD_BOM_FINISHED_GOODS_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.ADD_BOM_FINISHED_GOODS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const updateBOMFinishedGoodsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.UPDATE_BOM_FINISHED_GOODS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.UPDATE_BOM_FINISHED_GOODS_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.UPDATE_BOM_FINISHED_GOODS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const deleteBOMFinishedGoodsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.DELETE_BOM_FINISHED_GOODS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.DELETE_BOM_FINISHED_GOODS_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.DELETE_BOM_FINISHED_GOODS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};
 